<!-- Logo/Title (optional) -->
<div class="text-center mb-4" *ngIf="showLogo">
	<img
		src="assets/metapress_logo_dark.png"
		alt="MetaPress"
		class="mb-2"
		style="max-height: 60px"
		*ngIf="!isLoggingIn"
	/>
	<h2
		class="text-primary fw-bold mb-0"
		*ngIf="!isLoggingIn"
		style="font-size: 1.75rem"
	>
		MetaPress
	</h2>
</div>

<!-- Login form -->
<form (ngSubmit)="onLogin()" #loginForm="ngForm">
	<!-- Error alert -->
	<div *ngIf="loginError" class="alert alert-danger" role="alert">
		<i class="bi bi-exclamation-triangle-fill me-2"></i>
		{{ loginError }}
	</div>

	<!-- Username field -->
	<div class="mb-2">
		<input
			type="text"
			class="form-control"
			id="username"
			name="username"
			[(ngModel)]="username"
			(ngModelChange)="onFormChange()"
			required
			[disabled]="isLoggingIn"
			placeholder="Tunnus"
		/>
	</div>

	<!-- Password field -->
	<div class="mb-4">
		<input
			type="password"
			class="form-control"
			id="password"
			name="password"
			[(ngModel)]="password"
			(ngModelChange)="onFormChange()"
			required
			[disabled]="isLoggingIn"
			placeholder="Salasana"
		/>
	</div>

	<!-- Submit button -->
	<div class="d-flex justify-content-center flex-column">
		<button
			type="submit"
			class="btn btn-primary w-100"
			[disabled]="isLoggingIn || !loginForm.form.valid"
		>
			<span
				*ngIf="isLoggingIn"
				class="spinner-border spinner-md me-2"
				role="status"
			></span>
			<span *ngIf="isLoggingIn">
				<app-cycling-loading-messages
					class="d-inline-block"
					[loadingMessages]="[
						'Kirjaudutaan sisään...',
						'Odota vielä hetki...',
					]"
				></app-cycling-loading-messages>
			</span>
			<span *ngIf="!isLoggingIn">{{ buttonText }}</span>
		</button>
	</div>
</form>

<!-- <div style="position: absolute; bottom: 0; left: auto; right: auto">
	<div class="text-muted small mt-3">
		{{ settingsService.AppVersion }}.{{ settingsService.AppDataVersion
		}}{{ settingsService.AppVersionPostfix }}
	</div>
</div> -->
